export default __webpack_public_path__ + "static/media/RobertPerks.96ec19e2.png";